export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {
      prop: 'keyword',
      label: '关键词',
      minWidth: '80'
    },
    {
      prop: 'eventsId',
      label: '直播间',
      minWidth: '80'
    },
    {
      prop: 'times',
      label: '时间段',
      minWidth: '80'
    },
    {
      prop: 'totalNum',
      label: '统计量',
      minWidth: '80'
    },
    {
      label: '操作',
      minWidth: '60',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
